import { useState, useEffect } from 'react';

export const useIntersectionObserver: ({
	margin,
	threshold,
	onIntersection,
}: {
	margin: number;
	threshold?: number | undefined;
	onIntersection: (timestamp: number) => void;
}) => React.Dispatch<React.SetStateAction<Element | null>> = ({
	margin,
	threshold = 0,
	onIntersection,
}: {
	margin: number;
	threshold?: number;
	onIntersection: (timestamp: number) => void;
}): typeof setObservedElement => {
	const [observedElement, setObservedElement] = useState<Element | null>(null);
	useEffect(() => {
		// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
		if (observedElement === null || window.IntersectionObserver === undefined) {
			return undefined;
		}
		const observerCallback: IntersectionObserverCallback = (entries) =>
			entries.forEach(({ isIntersecting, time }) => {
				if (isIntersecting) {
					onIntersection(time);
				}
			});
		const observer = new IntersectionObserver(observerCallback, {
			rootMargin: `${margin}px`,
			threshold,
		});
		observer.observe(observedElement);
		return () => {
			observer.disconnect();
		};
	}, [observedElement, onIntersection, margin, threshold]);
	return setObservedElement;
};
